import { render, staticRenderFns } from "./guardian-card.vue?vue&type=template&id=570fdb7a"
import script from "./guardian-card.vue?vue&type=script&lang=js"
export * from "./guardian-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports